var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiving({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "M10.373 29.877c1.787-1.671 3.613-1.445 5.476.678l-5.678 5.311c-1.652-2.321-1.585-4.318.202-5.989Z",
    transform: "rotate(-16 12.415 32.32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D09D",
    d: "M11.76 43.075c.24-.177.554-.324 1.012-.034.206.167.414.328.622.48l-.189.266-2.615 1.394-.086-1.05c.45-.312.868-.662 1.257-1.056Zm6.978-14.708 1.559.014-.236 5.646-5.383 7.666c-.165-.123-.33-.25-.494-.384l-.215-.155c-.932-.59-1.871-.645-2.707-.331l7.476-12.456Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D09D",
    d: "M25.214 15.966c.467-.735 1.442-.953 2.178-.487.07.044.135.093.196.146l3.856 3.382-4.996 7.819-4.214 5.015.237-5.255-3.708-.461 6.451-10.16Zm18.599-15.966 2.393.863-6.863 11.91-6.01 4.743-4.183-3.667c-.154-.134-.318-.257-.49-.366-.1-.063-.201-.121-.304-.174l7.671-3.923 5.114-7.072 2.672-2.314Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "m29.12 16 3.14 4.881 0 0-6.957 6.14-5.433 3.658 1.676-4.986-3.438-1.465 9.507-8.436c.414-.366 1.046-.329 1.412.085.034.038.065.08.093.122Z",
    transform: "rotate(-16 25.185 22.848)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "m29.12 16 3.14 4.881 0 0-6.957 6.14-5.433 3.658 1.676-4.986-3.438-1.465 9.507-8.436c.414-.366 1.046-.329 1.412.085.034.038.065.08.093.122Z",
    transform: "rotate(-16 25.185 22.848)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#83B3F9",
    fillRule: "nonzero",
    d: "M12.288 46.993c-2.73 1.934-6.522 3.007-11.488 3.007-1.067 0-1.067-3.708 0-3.708 5.041 0 8.558-.785 10.96-3.217.24-.177.554-.324 1.012-.034 2.337 1.899 4.817 2.88 7.3 2.945l.466-.022c2.328-.169 4.645-1.143 6.835-2.923.458-.29.772-.143 1.012.034 2.402 2.432 5.817 3.217 10.859 3.217 1.3 0 1.3 3.708.102 3.708-4.967 0-8.758-1.073-11.489-3.007-2.446 1.788-5.114 2.69-7.784 2.714-2.671-.023-5.338-.926-7.785-2.714Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiving);
export default __webpack_public_path__ + "static/media/diving.14f07dfd5e7d808d64decca9ecf1a6b4.svg";
export { ForwardRef as ReactComponent };